<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="col-md-6 d-flex align-items-stretch mb-3">
            <div class="row flex-grow">
                <div class="col-12 p-0">
                    <div class="text-left">
                        <b-btn v-on:click="resetForm" variant="primary">
                            {{ $t('Add Survey') }}
                        </b-btn>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 stretch-card">
                <div class="card">
                    <div class="card-header">
                        <div class="d-flex align-items-center question-order row-question-order">
                            <h4 class="card-title">{{ $t('surveys') }}</h4>
                            <div class="header-buttons">
                                <button class="btn btn-primary" @click="showArchieved">{{ $t('Archived') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body new-card-body">
                        <vue-good-table
                                mode="remote"
                                @on-page-change="onPageChange"
                                @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                :totalRows="totalRecords"
                                :isLoading.sync="isLoading"
                                :pagination-options="{enabled: true,dropdownAllowAll: false,perPageDropdown: [10, 20, 50, 100, 200],}"
                                :rows="rows"
                                :columns="columns"
                                @on-search="searchFn"
                                :search-options="{enabled: true,searchFn: searchFn}"
                                :row-style-class="checkDeleted"
                                :line-numbers="true">
                                <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <toggle-button
                                        v-model="categories.find(p => p.id === props.row.id).show"
                                        @change="changeStatus(props.row.id, $event)"
                                        :sync="true" class="mr-1 switchColor"/>
                                    <b-button size="sm" @click="editSurvey(props.row.id)" class="mr-1 btn-info text-white">
                                        {{ $t('edit-btn') }}
                                    </b-button>
                                    <b-button size="sm" @click="deleteSurvey(props.row.id)"
                                        class="mr-1 btn-danger text-white">
                                        {{ $t('delete-btn') }}
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modalmd" ref="vuemodal" :title="title" size="md" hide-footer>
            <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">
                <div class="row">
                    <div class="col-md-6">
                    <b-form-group :label="$t('name*')" label-for="name">
                        <b-form-input type="text" id="name" name="name" autocomplete="new-password" :placeholder="$t('name-placeholder')" v-model="$v.form.name.$model" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" aria-describedby="input-1-live-feedback">
                        </b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">{{ $t("field-required") }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group id="survey_date" :label="$t('Survey Date')" label-for="survey_date">
                            <b-form-input id="survey_date" type="datetime-local" v-model="form.survey_date"></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <b-button type="submit" variant="success" :disabled="isDisabled" class="mr-2">
                    <span v-if="form.id == ''">{{ $t('submit-btn') }}</span>
                    <span v-else>{{ $t('update-btn') }}</span>
                </b-button>
            </form>
        </b-modal>
    </section>
</template>

<script>
    import Vue from "vue";
    import SortedTablePlugin from "vue-sorted-table";
    import API from '@/api'
    import Snotify, {SnotifyPosition} from 'vue-snotify'
    import {validationMixin} from "vuelidate";
    import {required, minLength, email, requiredIf, sameAs} from "vuelidate/lib/validators";
    import moment from 'moment'
    import i18n from '@/i18n';

    const options = {
        toast: {
            position: SnotifyPosition.rightTop,
        }
    }
    Vue.use(Snotify, options)
    Vue.use(SortedTablePlugin, {
        ascIcon: '<i class="ti-arrow-down"></i>',
        descIcon: '<i class="ti-arrow-up"></i>'
    });
    export default {
        name: 'Spotters',
        mixins: [validationMixin],
        data() {
            return {
                isDisabled: false,
                categories: [],
                title: i18n.t('Add Survey'),
                form: {
                    id: "",
                    name: "",
                    survey_date: "",
                    client_id: JSON.parse(localStorage.getItem('client_id')),
                    show: true,
                },
                serverParams: {
                    client_id: JSON.parse(localStorage.getItem('client_id')),
                    // a map of column filters example: {name: 'john', age: '20'}
                    columnFilters: {},
                    sort: [
                        {
                            field: 'id', // example: 'name'
                            type: 'desc' // 'asc' or 'desc'
                        }
                    ],

                    page: 1, // what page I want to show
                    perPage: 10 // how many items I'm showing per page
                },
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        filterable: true
                    },
                    {
                        label: 'Survey Date',
                        field: 'survey_date',
                        filterable: true
                    },
                    {
                        label: 'Created At',
                        field: 'created_at',
                        filterable: true
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true
                    },
                    {
                        label: 'Action',
                        field: "action",
                        sortable: false,
                    },
                ],
                isLoading: false,
                rows: [],
                totalRecords: 0,
            };
        },
        validations: {
            form: {
                id: {},
                name: {
                    required,
                },
            }
        },
        methods: {
            showArchieved() {
                this.$router.push("/surveys/archived", () => {});
            },
            deleteSurvey(e) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        // let data = {
                        //     id: e
                        // }
                        API.deleteSurvey(
                            e,
                            data => {
                                this.loadItems();
                                this.$snotify.success('Record has been deleted.');
                            },
                            err => {})
                    }
                })
            },
            changeStatus(id, event) {
                console.log(id, event.value);
                const data = {
                    id: id,
                    show: event.value === true ? 1 : 0
                };
                API.updateSurveyStatus(
                    data,
                    data => {
                        this.loadItems();
                        if (data.status === 200) {
                            this.$snotify.success(data.message);
                        }
                    },
                    err => {}
                );
            },
            onSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$anyError) {
                    return;
                }
                if (this.form.name != '') {
                    this.isDisabled = true;
                    const data = {
                        ...this.form,
                        selectedUser: this.selectedUser  
                    }
                    API.addEditSurvey(
                        data,
                        data => {
                            this.$refs["vuemodal"].$refs['close-button'].click();
                            if (data.status === 200) {
                                this.$snotify.success(data.message);
                            } else {
                                this.$snotify.error(data.message);
                            }
                            this.loadItems();
                            this.isDisabled = false;
                            this.form.name = '';
                            this.form.id = '';
                            // this.form.survey_date = '';
                            // var date_time = moment().format("YYYY-MM-DDTHH:mm");
                            // this.form.survey_date = date_time;
                            this.form.show = true;
                            this.$v.form.$reset();
    
    
                        },
                        err => {
                            this.isDisabled = false;
                            this.$snotify.error(err, {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                            });
    
                        }
                    )
                } else {
                    this.$snotify.warning('Please fill required fields', {
                        timeout: 2000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                    this.isDisabled = false;
                }
            },
            deleteSpotter(e) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "All spots against this spotter delete. You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        let data = {
                            id: e
                        }
                        API.deleteSpotter(
                            e,
                            data => {
                                this.loadItems();
                                this.$swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                )
                            },
                            err => {
                            })
                    }
                })
            },
            restoreSpotter(e) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "You want to restore Spotter!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Restore it!'
                }).then((result) => {
                    if (result.value) {
                        let data = {
                            id: e
                        }
                        API.restoreSpotter(
                            e,
                            data => {
                                this.loadItems();
                                this.$swal(
                                    'Restore!',
                                    'Record has been restored.',
                                    'success'
                                )
                            },
                            err => {
                            })
                    }
                })
            },
            permanentDeleteSpotter(e) {
                let data = {
                    id: e
                }
                API.permanentDeleteSpotter(
                    e,
                    data => {
                        this.loadItems();
                        this.$snotify.success(data.message);
                    },
                    err => {
                    })
            },
            // addSpotter() {
            //     this.$router.push({name: 'addSpotter'});
            // },
            resetForm() {
                this.title = i18n.t('Add Survey');
                this.form.name = '';
                this.form.id = '';
                var date_time = moment().format("YYYY-MM-DDTHH:mm");
                this.form.survey_date = date_time;
                this.$v.form.$reset();
                this.$root.$emit("bv::show::modal", "modalmd");
            },
            // editSpotter(e) {
            //     this.$router.push({name: 'editSpotter', params: {id: e}});
            // },
            editSurvey(e) {
                this.$v.form.$reset();
                this.title = i18n.t('Edit Survey');
                this.$root.$emit("bv::show::modal", "modalmd");
                API.getSurvey(
                    e, data => {
                        this.form.name = data.name;
                        this.form.id = data.id;
                        this.form.survey_date = data.survey_date;
                        const formattedDate = moment(data.survey_date, 'MM-DD-YYYY HH:mm').format('YYYY-MM-DDTHH:mm');
                        this.form.survey_date = formattedDate;
                        this.form.show = (data.data.show == 1) ? true : false;
                    },
                    err => {}
                )
            },
            loadItems() {
                this.isLoading = true;
                API.getSurveys(this.serverParams,
                    data => {
                        this.isLoading = false;
                        this.totalRecords = data.totalRecords;
                        this.rows = data.data.data;
                        this.rows.forEach(q => {
                            const data = {
                                id: q.id,
                                show: q.show === 1 ? true : false
    
                            };
                            this.categories.push(data);
                        });
                    },
                    err => {
                    }
                )
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('YYYY-MM-DD')
                }
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            searchFn(params) {
                console.log('okkok')
                this.updateParams({searchTerm: params});
                this.loadItems();
                this.isLoading = false;
            },
            formatStatus(status) {
                if (status === 1) {
                    return 'Yes';
                } else {
                    return 'No';
                }
            },
            trainingStatus(training_status) {
                if (training_status == 1) {
                    return 'Yes';
                } else {
                    return 'No';
                }
            },
            status(status) {
                if (status === 'A') {
                    return 'Yes';
                } else {
                    return 'No';
                }
            },
            checkDeleted(row) {
                console.log(row.deleted_at);
                return row.deleted_at !== null ? 'red-text' : '';
            },
        }, computed: {},
        mounted() {
            var date_time = moment().format("YYYY-MM-DDTHH:mm");
            this.form.survey_date = date_time;
            this.isLoading = true;
            this.loadItems();
        }
    }
</script>

<style lang="scss">
    .red-text .vgt-left-align {
        color: red !important;
    }
    .btn-disabled {
        width: 100px;
    }
    .btn-restore {
        width: 70px !important;
        padding-left: 10px !important;
        background: #5D9E12;
        border-color: #5D9E12;
    }
    @media (max-width: 1150px) {
        .card .new-card-body {
            padding: 1.25rem 1.437rem !important;
        }
    }
</style>

